<ng-container *ngIf="name && (imageUrl$ | async) as imageUrl; else defaultImage">
  <img [src]="imageUrl" alt="Doctors4UA"/>
</ng-container>

<ng-template #defaultImage>
  <div class="empty_avatar">
    <img [src]="'/assets/images/' + default" alt="Doctors4UA"/>
  </div>
</ng-template>
